import React, { useEffect, useLayoutEffect } from 'react';
import StatusBar from 'design-system/StatusBar';
import { AppView } from 'design-system/AppView';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { IconEdit } from 'design-system/icons/IconEdit';
import useColors from 'hooks/useColors';
import WalkthroughHeaderOverlay from 'features/feed/components/walkthrough/WalkthroughHeaderOverlay';
import { useIsMainAppWalkthroughV6Active } from 'features/feed/components/walkthrough/hooks/useIsMainAppWalkthroughV6Active';
import { useAppDispatch, useAppStore } from 'store/hooks';
import AnalyticsList from '../components/AnalyticsList';
import { ManageAnalyticsModal } from '../components/ManageAnalyticsModal';
import { SelectedCategoryContextProvider } from '../hooks/useSelectedCategory';
import { selectChartType } from '../selectors';
import { setChartType } from '../actions';
const AnalyticsScreen = withAnimatedNavigationHeader(({ scrollY, navigation, route }) => {
    const colors = useColors();
    const isMainWalkthroughActive = useIsMainAppWalkthroughV6Active();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => (<NavigationHeaderRightIconButton onPress={ManageAnalyticsModal.show} disabled={isMainWalkthroughActive}>
            <IconEdit color={isMainWalkthroughActive
                    ? colors.elements.primaryOnModal
                    : colors.buttons.primary}/>
          </NavigationHeaderRightIconButton>),
        });
    }, [
        colors.buttons.primary,
        colors.elements.primaryOnModal,
        isMainWalkthroughActive,
    ]);
    const dispatch = useAppDispatch();
    const store = useAppStore();
    useEffect(() => {
        const state = store.getState();
        const chartType = selectChartType(state);
        const routeChartType = route.params?.chartType;
        const shouldUpdateChartType = routeChartType && chartType !== routeChartType;
        if (shouldUpdateChartType) {
            dispatch(setChartType(routeChartType));
        }
        return () => {
            const latestChartType = selectChartType(store.getState());
            if (shouldUpdateChartType && latestChartType === routeChartType) {
                dispatch(setChartType(chartType));
            }
        };
        // Only update chart type on mount and revert to original on unmount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<SelectedCategoryContextProvider>
        <AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <AnalyticsList scrollY={scrollY}/>
        </AppView>
      </SelectedCategoryContextProvider>);
}, ({ colors, route }) => ({
    Overlay: () => <WalkthroughHeaderOverlay v6/>,
    title: 'Analytics',
    headerTintColor: route.params?.headerTintColor,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default AnalyticsScreen;
